export enum AchievementCategory {
  GAMEPLAY = 'GAMEPLAY',
  SOCIAL = 'SOCIAL',
  PROGRESSION = 'PROGRESSION',
  COMMUNITY = 'COMMUNITY',
  CUSTOM = 'CUSTOM',
}

export enum AchievementTier {
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
}

export enum AchievementRewardType {
  NONE = 'NONE',
  WALLET_CREDITS = 'WALLET_CREDITS',
  COUPON = 'COUPON',
}

export enum StreakActivityType {
  GAME = 'GAME',
  COURT_BOOKING = 'COURT_BOOKING',
  EVENT = 'EVENT',
  COACHING = 'COACHING',
  ANY = 'ANY',
}

export enum StreakPeriodType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export type AchievementCriteriaType =
  | 'games_played'
  | 'courts_booked'
  | 'events_joined'
  | 'coaching_sessions'
  | 'matches_won'
  | 'streak'
  | 'unique_opponents'
  | 'level_reached';

export type TimeConstraintDto = {
  before?: string;
  after?: string;
};

export type AchievementCriteria = {
  type: AchievementCriteriaType;
  threshold: number;
  sport?: string;
  activityType?: StreakActivityType;
  periodType?: StreakPeriodType;
  timeConstraint?: TimeConstraintDto;
};

export type AchievementDefinitionDto = {
  id: string;
  name: string;
  description?: string;
  category: AchievementCategory;
  tier?: AchievementTier;
  iconUrl?: string;
  sportType?: string;
  criteria: AchievementCriteria;
  isActive: boolean;
  sortOrder: number;
  rewardType?: AchievementRewardType;
  rewardValue?: number;
  rewardCouponId?: string;
  createdAt: string;
  updatedAt: string;
};

export type UserAchievementDto = {
  id: string;
  achievement: AchievementDefinitionDto;
  unlockedAt: string;
};

export type AchievementProgressDto = {
  achievementDefinitionId: string;
  current: number;
  threshold: number;
  percentage: number;
};

export type UserStreakDto = {
  id: string;
  activityType: StreakActivityType;
  sportType?: string;
  periodType: StreakPeriodType;
  currentStreak: number;
  longestStreak: number;
  lastQualifyingDate?: string;
};

export class CreateAchievementDefinitionDto {
  name: string;

  description?: string;

  category: AchievementCategory;

  tier?: AchievementTier;

  iconUrl?: string;

  sportType?: string;

  criteria: AchievementCriteria;

  isActive?: boolean;

  sortOrder?: number;

  rewardType?: AchievementRewardType;

  rewardValue?: number;

  rewardCouponId?: string;
}

export class UpdateAchievementDefinitionDto {
  name?: string;

  description?: string;

  category?: AchievementCategory;

  tier?: AchievementTier;

  iconUrl?: string;

  sportType?: string;

  criteria?: AchievementCriteria;

  isActive?: boolean;

  sortOrder?: number;

  rewardType?: AchievementRewardType;

  rewardValue?: number;

  rewardCouponId?: string;
}
